import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import MySideBar from '../common/MySideBar';
import ListProjects from './ListProjects';

//Create Project dependencies
import MyTooltip from '../common/MyTooltip';
import CreateProjectModel from './CreateProjectModel';

import {
  CREATE_PROJECT_MODEL_ACTION_CREATE, 
  CREATE_PROJECT_MODEL_ACTION_EDIT,
  CREATE_PROJECT_MODEL_ACTION_SHOW,
  ROLE_VIEWER
} from '../common/redux/constantes';




export class DefaultPage extends Component {
  state = {
    openCreateProjectDialog:false,
    createProjectDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
    projectEdit:{}
  }


  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };


  closeCreateProjectDialog = ()=>{
    this.setState({openCreateProjectDialog:false});
    this.list.wrappedInstance.refreshTable();
  }

  openCreateProjectDialog = ()=>{
    this.setState({
      openCreateProjectDialog:true, 
      createProjectDialogAction:CREATE_PROJECT_MODEL_ACTION_CREATE,
      projectEdit:{}
    });
  }

  editProject = (project)=>{
     this.setState({
      openCreateProjectDialog:true, 
      createProjectDialogAction:CREATE_PROJECT_MODEL_ACTION_EDIT,
      projectEdit:project
    });
  }

  showProject = (project)=>{
     this.setState({
      openCreateProjectDialog:true, 
      createProjectDialogAction:CREATE_PROJECT_MODEL_ACTION_SHOW,
      projectEdit:project
    });
  }

  render() {
    
    return (
      <div >
        <MySideBar>
          <ListProjects ref={instance => { this.list = instance; }} editProject={this.editProject} showProject={this.showProject}/>
          <CreateProjectModel 
            openDialog={this.state.openCreateProjectDialog} 
            closeDialog={this.closeCreateProjectDialog} 
            actionDialog={this.state.createProjectDialogAction}
            projectEdit={this.state.projectEdit}
          />
          
          {Number(localStorage.getItem("role")) !== ROLE_VIEWER?
          (
            <MyTooltip withChat={true} openDialog={this.openCreateProjectDialog} />
          ):null}
      </MySideBar>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);



// WEBPACK FOOTER //
// ./src/features/home/DefaultPage.js